/*
 * moeka-favourites.js — ハートのお気に入り（アプリ不使用・ログイン不要・UX-238・2026-09-26）
 *  1. localStorage（moeka:favourites）に商品 handle を最新順・重複なし・最大 50 件で持つ（サーバーへは送らない）
 *  2. [data-moeka-fav] のハートは JS が動いた時だけ表示し（hidden を外す）、押すとその場で切り替える
 *  3. ヘッダーの [data-moeka-fav-link] を表示し、[data-moeka-fav-count] に件数（0 件なら数字だけ隠す）
 *  4. <moeka-favourites>（/pages/favorites）が保存した商品を /products/<handle>.js から描く（最近見た商品と同じ方式）
 *  5. window.MOEKA_FAV = { list, has, add, remove, toggle }。変わると document に "moeka:fav-change"
 *  JS 無効時: ハートもヘッダーのリンクも出ない（hidden のまま）＝回遊は今までどおり。
 */
(function () {
  'use strict';
  if (window.MOEKA_FAV) return;

  var KEY = 'moeka:favourites';
  var LIMIT = 50;

  function read() {
    try {
      var arr = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (h) { return typeof h === 'string' && h.length > 0; });
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  }
  function emit() {
    try { document.dispatchEvent(new CustomEvent('moeka:fav-change', { detail: { list: read() } })); } catch (e) { /* old browsers */ }
  }
  function has(handle) { return read().indexOf(handle) > -1; }
  function add(handle) {
    if (!handle) return read();
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list.slice(0, LIMIT));
    emit();
    return read();
  }
  function remove(handle) {
    write(read().filter(function (h) { return h !== handle; }));
    emit();
    return read();
  }
  /* 計測（第2段階・2026-09-26）: 押した事実だけを Shopify の customer events へ出す（moeka:favourite）。
     個人情報は送らない。受け取るのは管理画面の custom pixel（GA4 へ add_to_wishlist として転送）。pixel が無ければ何も起きない。 */
  function track(action, btn) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (!a || typeof a.publish !== 'function') return;
      var price = parseFloat(btn.getAttribute('data-moeka-fav-price') || '');
      a.publish('moeka:favourite', {
        action: action,
        handle: btn.getAttribute('data-moeka-fav') || '',
        productId: btn.getAttribute('data-moeka-fav-id') || null,
        title: btn.getAttribute('data-moeka-fav-title') || '',
        price: isNaN(price) ? null : price,
        currency: btn.getAttribute('data-moeka-fav-currency') || null,
        surface: btn.closest('moeka-favourites') ? 'favorites' : (btn.classList.contains('moeka-fav--pdp') ? 'product' : 'card'),
        count: read().length
      });
    } catch (e) { /* 計測は本体の動きを止めない */ }
  }
  function toggle(handle) {
    if (has(handle)) { remove(handle); return false; }
    add(handle);
    return true;
  }

  /* ---- ハートの表示（一覧カード・商品ページ・お気に入りページのカード） ---- */
  function paintButtons(root) {
    var list = read();
    (root || document).querySelectorAll('[data-moeka-fav]').forEach(function (btn) {
      var handle = btn.getAttribute('data-moeka-fav');
      if (!handle) return;
      var on = list.indexOf(handle) > -1;
      var title = btn.getAttribute('data-moeka-fav-title') || 'this item';
      btn.hidden = false;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-label', on ? 'Remove ' + title + ' from favorites' : 'Save ' + title + ' to favorites');
      var label = btn.querySelector('[data-moeka-fav-label]');
      if (label) label.textContent = on ? (label.getAttribute('data-label-on') || 'Saved') : (label.getAttribute('data-label-off') || 'Save to favorites');
    });
  }

  /* ---- ヘッダーの件数 ---- */
  function paintHeader() {
    var n = read().length;
    document.querySelectorAll('[data-moeka-fav-link]').forEach(function (link) {
      link.hidden = false;
      link.classList.toggle('has-items', n > 0);
      link.setAttribute('aria-label', n > 0 ? 'Favorites, ' + n + (n === 1 ? ' item' : ' items') : 'Favorites');
      var count = link.querySelector('[data-moeka-fav-count]');
      if (count) { count.textContent = n > 99 ? '99+' : String(n); count.hidden = n === 0; }
    });
  }

  function paintAll(root) { paintButtons(root); paintHeader(); }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-moeka-fav]') : null;
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    var handle = btn.getAttribute('data-moeka-fav');
    var on = toggle(handle);
    track(on ? 'add' : 'remove', btn);
    if (on) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth; /* restart the animation */
      btn.classList.add('is-pop');
    }
    paintAll();
  }, true);

  /* ---- /pages/favorites: 保存した商品を描く ---- */
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    var value = (cents / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    function withCommas(num) { var parts = num.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return parts.join('.'); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, token) {
      switch (token) {
        case 'amount': return withCommas(value);
        case 'amount_no_decimals': return withCommas((cents / 100).toFixed(0));
        case 'amount_with_comma_separator': return value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_no_decimals_with_comma_separator': return (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withCommas(value);
      }
    });
  }
  function sized(url, width) {
    try { var u = new URL(url, window.location.origin); u.searchParams.set('width', String(width)); return u.toString(); } catch (e) { return url; }
  }

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  if (window.customElements && !customElements.get('moeka-favourites')) {
    class MoekaFavourites extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
        this.currency = this.getAttribute('data-currency') || '';
        this.grid = this.querySelector('[data-moeka-fav-grid]');
        this.template = this.querySelector('[data-moeka-fav-template]');
        this.empty = this.querySelector('[data-moeka-fav-empty]');
        this.total = this.querySelector('[data-moeka-fav-total]');
        this._onChange = this.render.bind(this);
        document.addEventListener('moeka:fav-change', this._onChange);
        this.render();
      }
      disconnectedCallback() { document.removeEventListener('moeka:fav-change', this._onChange); }
      render() {
        var self = this;
        var handles = read();
        if (!this.grid || !this.template) return;
        if (this.empty) this.empty.hidden = handles.length > 0;
        if (this.total) this.total.textContent = handles.length ? handles.length + (handles.length === 1 ? ' item saved on this device' : ' items saved on this device') : '';
        if (!handles.length) { this.grid.innerHTML = ''; return; }
        /* 先に骨組み（写真の枠だけ）を並べて高さを確保する＝取得を待つ間に下の段が動かない（CLS 対策） */
        if (!this.grid.children.length) {
          var skeleton = document.createDocumentFragment();
          handles.forEach(function () {
            var f = self.template.content.cloneNode(true);
            var wrap = f.firstElementChild;
            var b = f.querySelector('[data-moeka-fav]'); if (b) b.remove();
            var im = f.querySelector('img'); if (im) im.remove();
            if (wrap) { wrap.classList.add('is-loading'); wrap.setAttribute('aria-hidden', 'true'); }
            skeleton.appendChild(f);
          });
          this.grid.appendChild(skeleton);
        }
        var token = (this._token = (this._token || 0) + 1);
        Promise.all(handles.map(fetchProduct)).then(function (products) {
          if (token !== self._token) return; /* a newer render started */
          var frag = document.createDocumentFragment();
          var missing = [];
          products.forEach(function (p, i) {
            if (!p || !p.handle) { missing.push(handles[i]); return; }
            frag.appendChild(self._card(p));
          });
          self.grid.innerHTML = '';
          self.grid.appendChild(frag);
          /* 消えた商品（非公開・削除）は静かに外す */
          if (missing.length) { write(read().filter(function (h) { return missing.indexOf(h) < 0; })); paintHeader(); }
          paintButtons(self.grid);
        });
      }
      _card(p) {
        var frag = this.template.content.cloneNode(true);
        var link = frag.querySelector('a');
        var img = frag.querySelector('img');
        var title = frag.querySelector('[data-field="title"]');
        var price = frag.querySelector('[data-field="price"]');
        var btn = frag.querySelector('[data-moeka-fav]');
        var src = p.featured_image || (p.images && p.images[0]) || '';
        if (link) { link.href = p.url || '/products/' + p.handle; link.setAttribute('aria-label', p.title || ''); }
        if (img) { if (src) { img.src = sized(src, 600); img.alt = p.title || ''; } else { img.remove(); } }
        if (title) title.textContent = p.title || '';
        if (price) price.textContent = formatMoney(p.price, this.moneyFormat);
        if (btn) {
          btn.setAttribute('data-moeka-fav', p.handle); btn.setAttribute('data-moeka-fav-title', p.title || '');
          btn.setAttribute('data-moeka-fav-id', String(p.id || '')); btn.setAttribute('data-moeka-fav-price', typeof p.price === 'number' ? (p.price / 100).toFixed(2) : ''); btn.setAttribute('data-moeka-fav-currency', this.currency);
        }
        return frag;
      }
    }
    customElements.define('moeka-favourites', MoekaFavourites);
  }

  window.MOEKA_FAV = { list: read, has: has, add: add, remove: remove, toggle: toggle, paint: paintAll };

  function boot() { paintAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { paintAll(); });
  /* 別タブでの変更も反映 */
  window.addEventListener('storage', function (ev) { if (ev.key === KEY) { paintAll(); emit(); } });
})();
